import ClosedCaptions from './closed_captions'
export default ClosedCaptions
